import { ReactNode } from 'react';
import { cx } from '@libs/classnames';
import styles from './AnouncementSection.module.css';
import { AnouncementPanel } from '@features/landing/shared/ui/components/AnouncementPanel';
import { LandingSection } from '@features/landing/shared/ui/components/LandingSection';

export type AnouncementSectionProps = {
  title: ReactNode;
  tags: ReactNode;
  panelDisclaimer?: ReactNode;
  disclaimer?: ReactNode;
  className?: string;
};

export function AnouncementSection({
  title,
  tags,
  panelDisclaimer,
  disclaimer,
  className,
}: AnouncementSectionProps) {
  return (
    <LandingSection>
      <div className={cx(styles.root, className)}>
        <div className={styles.anouncementPanelWrapper}>
          <div className={styles.anouncementPanel}>
            <AnouncementPanel
              title={title}
              tags={tags}
              disclaimer={panelDisclaimer}
            />

            {disclaimer && (
              <div className={styles.disclaimer}>{disclaimer}</div>
            )}
          </div>
        </div>
      </div>
    </LandingSection>
  );
}
